/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SentryTestRouteImport } from './routes/sentry-test'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardKomisiRouteImport } from './routes/dashboard/komisi'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardTransactionsIndexRouteImport } from './routes/dashboard/transactions/index'
import { Route as DashboardTransactionRequestsIndexRouteImport } from './routes/dashboard/transaction-requests/index'
import { Route as DashboardReportsIndexRouteImport } from './routes/dashboard/reports/index'
import { Route as DashboardProgramsIndexRouteImport } from './routes/dashboard/programs/index'
import { Route as DashboardMasterDataIndexRouteImport } from './routes/dashboard/master-data/index'
import { Route as DashboardUsersUserIdRouteImport } from './routes/dashboard/users/$userId'
import { Route as DashboardTransactionsRequestIdRouteImport } from './routes/dashboard/transactions/$requestId'
import { Route as DashboardProgramsProgramIdRouteImport } from './routes/dashboard/programs/$programId'
import { Route as DashboardTransactionsDetailTransactionIdRouteImport } from './routes/dashboard/transactions/detail/$transactionId'

const SentryTestRoute = SentryTestRouteImport.update({
  id: '/sentry-test',
  path: '/sentry-test',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardKomisiRoute = DashboardKomisiRouteImport.update({
  id: '/komisi',
  path: '/komisi',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTransactionsIndexRoute =
  DashboardTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTransactionRequestsIndexRoute =
  DashboardTransactionRequestsIndexRouteImport.update({
    id: '/transaction-requests/',
    path: '/transaction-requests/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardProgramsIndexRoute = DashboardProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMasterDataIndexRoute =
  DashboardMasterDataIndexRouteImport.update({
    id: '/master-data/',
    path: '/master-data/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardUsersUserIdRoute = DashboardUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTransactionsRequestIdRoute =
  DashboardTransactionsRequestIdRouteImport.update({
    id: '/transactions/$requestId',
    path: '/transactions/$requestId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProgramsProgramIdRoute =
  DashboardProgramsProgramIdRouteImport.update({
    id: '/programs/$programId',
    path: '/programs/$programId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTransactionsDetailTransactionIdRoute =
  DashboardTransactionsDetailTransactionIdRouteImport.update({
    id: '/transactions/detail/$transactionId',
    path: '/transactions/detail/$transactionId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/sentry-test': typeof SentryTestRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/dashboard/komisi': typeof DashboardKomisiRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/programs/$programId': typeof DashboardProgramsProgramIdRoute
  '/dashboard/transactions/$requestId': typeof DashboardTransactionsRequestIdRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/master-data': typeof DashboardMasterDataIndexRoute
  '/dashboard/programs': typeof DashboardProgramsIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/transaction-requests': typeof DashboardTransactionRequestsIndexRoute
  '/dashboard/transactions': typeof DashboardTransactionsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/transactions/detail/$transactionId': typeof DashboardTransactionsDetailTransactionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sentry-test': typeof SentryTestRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/dashboard/komisi': typeof DashboardKomisiRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/programs/$programId': typeof DashboardProgramsProgramIdRoute
  '/dashboard/transactions/$requestId': typeof DashboardTransactionsRequestIdRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/master-data': typeof DashboardMasterDataIndexRoute
  '/dashboard/programs': typeof DashboardProgramsIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/transaction-requests': typeof DashboardTransactionRequestsIndexRoute
  '/dashboard/transactions': typeof DashboardTransactionsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/transactions/detail/$transactionId': typeof DashboardTransactionsDetailTransactionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/sentry-test': typeof SentryTestRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/dashboard/komisi': typeof DashboardKomisiRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/programs/$programId': typeof DashboardProgramsProgramIdRoute
  '/dashboard/transactions/$requestId': typeof DashboardTransactionsRequestIdRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/master-data/': typeof DashboardMasterDataIndexRoute
  '/dashboard/programs/': typeof DashboardProgramsIndexRoute
  '/dashboard/reports/': typeof DashboardReportsIndexRoute
  '/dashboard/transaction-requests/': typeof DashboardTransactionRequestsIndexRoute
  '/dashboard/transactions/': typeof DashboardTransactionsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/transactions/detail/$transactionId': typeof DashboardTransactionsDetailTransactionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/sentry-test'
    | '/auth/login'
    | '/auth/reset-password'
    | '/dashboard/komisi'
    | '/dashboard/'
    | '/dashboard/programs/$programId'
    | '/dashboard/transactions/$requestId'
    | '/dashboard/users/$userId'
    | '/dashboard/master-data'
    | '/dashboard/programs'
    | '/dashboard/reports'
    | '/dashboard/transaction-requests'
    | '/dashboard/transactions'
    | '/dashboard/users'
    | '/dashboard/transactions/detail/$transactionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sentry-test'
    | '/auth/login'
    | '/auth/reset-password'
    | '/dashboard/komisi'
    | '/dashboard'
    | '/dashboard/programs/$programId'
    | '/dashboard/transactions/$requestId'
    | '/dashboard/users/$userId'
    | '/dashboard/master-data'
    | '/dashboard/programs'
    | '/dashboard/reports'
    | '/dashboard/transaction-requests'
    | '/dashboard/transactions'
    | '/dashboard/users'
    | '/dashboard/transactions/detail/$transactionId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/sentry-test'
    | '/auth/login'
    | '/auth/reset-password'
    | '/dashboard/komisi'
    | '/dashboard/'
    | '/dashboard/programs/$programId'
    | '/dashboard/transactions/$requestId'
    | '/dashboard/users/$userId'
    | '/dashboard/master-data/'
    | '/dashboard/programs/'
    | '/dashboard/reports/'
    | '/dashboard/transaction-requests/'
    | '/dashboard/transactions/'
    | '/dashboard/users/'
    | '/dashboard/transactions/detail/$transactionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  SentryTestRoute: typeof SentryTestRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sentry-test': {
      id: '/sentry-test'
      path: '/sentry-test'
      fullPath: '/sentry-test'
      preLoaderRoute: typeof SentryTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/komisi': {
      id: '/dashboard/komisi'
      path: '/komisi'
      fullPath: '/dashboard/komisi'
      preLoaderRoute: typeof DashboardKomisiRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/transactions/': {
      id: '/dashboard/transactions/'
      path: '/transactions'
      fullPath: '/dashboard/transactions'
      preLoaderRoute: typeof DashboardTransactionsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/transaction-requests/': {
      id: '/dashboard/transaction-requests/'
      path: '/transaction-requests'
      fullPath: '/dashboard/transaction-requests'
      preLoaderRoute: typeof DashboardTransactionRequestsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/reports/': {
      id: '/dashboard/reports/'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/programs/': {
      id: '/dashboard/programs/'
      path: '/programs'
      fullPath: '/dashboard/programs'
      preLoaderRoute: typeof DashboardProgramsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/master-data/': {
      id: '/dashboard/master-data/'
      path: '/master-data'
      fullPath: '/dashboard/master-data'
      preLoaderRoute: typeof DashboardMasterDataIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/users/$userId': {
      id: '/dashboard/users/$userId'
      path: '/users/$userId'
      fullPath: '/dashboard/users/$userId'
      preLoaderRoute: typeof DashboardUsersUserIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/transactions/$requestId': {
      id: '/dashboard/transactions/$requestId'
      path: '/transactions/$requestId'
      fullPath: '/dashboard/transactions/$requestId'
      preLoaderRoute: typeof DashboardTransactionsRequestIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/programs/$programId': {
      id: '/dashboard/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/dashboard/programs/$programId'
      preLoaderRoute: typeof DashboardProgramsProgramIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/transactions/detail/$transactionId': {
      id: '/dashboard/transactions/detail/$transactionId'
      path: '/transactions/detail/$transactionId'
      fullPath: '/dashboard/transactions/detail/$transactionId'
      preLoaderRoute: typeof DashboardTransactionsDetailTransactionIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardKomisiRoute: typeof DashboardKomisiRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardProgramsProgramIdRoute: typeof DashboardProgramsProgramIdRoute
  DashboardTransactionsRequestIdRoute: typeof DashboardTransactionsRequestIdRoute
  DashboardUsersUserIdRoute: typeof DashboardUsersUserIdRoute
  DashboardMasterDataIndexRoute: typeof DashboardMasterDataIndexRoute
  DashboardProgramsIndexRoute: typeof DashboardProgramsIndexRoute
  DashboardReportsIndexRoute: typeof DashboardReportsIndexRoute
  DashboardTransactionRequestsIndexRoute: typeof DashboardTransactionRequestsIndexRoute
  DashboardTransactionsIndexRoute: typeof DashboardTransactionsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardTransactionsDetailTransactionIdRoute: typeof DashboardTransactionsDetailTransactionIdRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardKomisiRoute: DashboardKomisiRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardProgramsProgramIdRoute: DashboardProgramsProgramIdRoute,
  DashboardTransactionsRequestIdRoute: DashboardTransactionsRequestIdRoute,
  DashboardUsersUserIdRoute: DashboardUsersUserIdRoute,
  DashboardMasterDataIndexRoute: DashboardMasterDataIndexRoute,
  DashboardProgramsIndexRoute: DashboardProgramsIndexRoute,
  DashboardReportsIndexRoute: DashboardReportsIndexRoute,
  DashboardTransactionRequestsIndexRoute:
    DashboardTransactionRequestsIndexRoute,
  DashboardTransactionsIndexRoute: DashboardTransactionsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardTransactionsDetailTransactionIdRoute:
    DashboardTransactionsDetailTransactionIdRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  SentryTestRoute: SentryTestRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
